export class NotFoundError extends Error {
    name = 'NotFoundError';
}
